export const INVOICING = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.03223 17.2148V25.3651H3.0323V60.0664C3.0323 64.2336 6.40894 67.6102 10.5762 67.6102H31.6991V25.3648H31.699V1.82837H21.8406L3.03223 17.2148ZM60.6678 9.37224V25.3652H31.6993V1.82841H53.1239C57.2912 1.82841 60.6678 5.20503 60.6678 9.37224Z" fill="#ED6CD5"/>
<path d="M60.6677 25.3647V60.0664C60.6677 64.2336 57.2911 67.6102 53.1239 67.6102H31.6992V25.3647H60.6677Z" fill="#ED6CD5"/>
<path opacity="0.8" d="M31.6992 25.3647H70.4235C74.5877 25.3647 77.9674 28.7444 77.9674 32.9086V70.6277C77.9674 74.7919 74.5877 78.1715 70.4235 78.1715H39.2431C35.0789 78.1715 31.6992 74.7919 31.6992 70.6277V25.3647Z" fill="url(#paint0_linear_3039_4871)"/>
<path d="M3.03223 17.2178H16.8074C19.5051 17.2389 21.7109 15.0753 21.738 12.3777V1.82837L3.03223 17.2178Z" fill="#DA2CBD"/>
<defs>
<linearGradient id="paint0_linear_3039_4871" x1="54.8333" y1="25.3647" x2="54.768" y2="95.7823" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFE0CF"/>
<stop offset="0.359375" stop-color="#FFCFD5"/>
<stop offset="1" stop-color="#E964FF"/>
</linearGradient>
</defs>
</svg>
`

export const PAYMENTS = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64.3863" height="47.7592" rx="2.6732" transform="matrix(4.37116e-08 -1 -1 -4.37111e-08 57.6533 66.9614)" fill="#FF9365"/>
<g opacity="0.9">
<rect width="64.3863" height="47.7592" rx="4.29" transform="matrix(4.37116e-08 -1 -1 -4.37111e-08 71.106 77.4247)" fill="url(#paint0_linear_3016_4529)"/>
</g>
<rect width="10.4632" height="13.9509" rx="2.86" transform="matrix(-1 -4.37111e-08 -4.37116e-08 1 61.0884 22.038)" fill="#D57A54"/>
<defs>
<linearGradient id="paint0_linear_3016_4529" x1="38.325" y1="0" x2="38.325" y2="47.7592" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFEACA"/>
<stop offset="1" stop-color="#FFB445" stop-opacity="0.7"/>
</linearGradient>
</defs>
</svg>
`

export const SUBSCRIPTION_MANAGER = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="28.9811" cy="39.9544" rx="27.5565" ry="27.8117" transform="rotate(-90 28.9811 39.9544)" fill="#7552D0"/>
<ellipse cx="40.6393" cy="40.0002" rx="27.5565" ry="27.8117" transform="rotate(-90 40.6393 40.0002)" fill="#AF95F8"/>
<ellipse opacity="0.8" cx="52.0187" cy="40.0455" rx="27.5565" ry="27.8117" transform="rotate(-90 52.0187 40.0455)" fill="url(#paint0_linear_3039_5282)"/>
<defs>
<linearGradient id="paint0_linear_3039_5282" x1="49.5182" y1="15.5942" x2="65.8952" y2="77.5452" gradientUnits="userSpaceOnUse">
<stop stop-color="#F3C3FF"/>
<stop offset="0.658067" stop-color="#C7BCFD"/>
</linearGradient>
</defs>
</svg>
`

export const CUSTOMER_MANAGEMENT = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M67.7531 37.1245C66.7199 36.3655 66.4272 34.9255 67.0284 33.7933C68.516 30.9914 69.3588 27.7949 69.3588 24.4014C69.3588 13.3252 60.3798 4.34619 49.3036 4.34619C38.2274 4.34619 29.2484 13.3252 29.2484 24.4014C29.2484 27.7946 30.0911 30.991 31.5786 33.7927C32.1797 34.9249 31.8869 36.365 30.8538 37.1239C23.1235 42.8019 18.106 51.9567 18.106 62.2835V72.3112C18.106 74.1572 19.6025 75.6537 21.4485 75.6537H77.1575C79.0035 75.6537 80.5 74.1572 80.5 72.3112V62.2836C80.5 51.9571 75.4828 42.8025 67.7531 37.1245Z" fill="url(#paint0_linear_2903_8921)"/>
<path opacity="0.75" fill-rule="evenodd" clip-rule="evenodd" d="M52.0911 36.8614C50.9333 35.9195 50.5688 34.2876 51.1409 32.9091C52.1477 30.483 52.7034 27.8224 52.7034 25.0321C52.7034 13.6744 43.4961 4.46716 32.1384 4.46716C20.7807 4.46716 11.5734 13.6744 11.5734 25.0321C11.5734 27.8224 12.1292 30.483 13.136 32.9091C13.708 34.2876 13.3435 35.9195 12.1858 36.8614C5.0552 42.6625 0.5 51.5075 0.5 61.4163V72.2129C0.5 74.1132 2.04044 75.6536 3.94068 75.6536H60.3362C62.2364 75.6536 63.7768 74.1132 63.7768 72.2129V61.4163C63.7768 51.5075 59.2216 42.6625 52.0911 36.8614Z" fill="url(#paint1_linear_2903_8921)"/>
<defs>
<linearGradient id="paint0_linear_2903_8921" x1="65" y1="15" x2="8.70993" y2="116.173" gradientUnits="userSpaceOnUse">
<stop stop-color="#E05871"/>
<stop offset="1" stop-color="#AF2D45"/>
</linearGradient>
<linearGradient id="paint1_linear_2903_8921" x1="21.9376" y1="3.73159" x2="30.7354" y2="97.63" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFC0F1"/>
<stop offset="0.338542" stop-color="#F26F87"/>
<stop offset="1" stop-color="#CF415B"/>
</linearGradient>
</defs>
</svg>
`

export const VIRTUAL_TERMINAL = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="61.5361" height="45.6444" rx="4.28571" transform="matrix(-1 0 0 1 64.5444 3.75928)" fill="#00B0A3"/>
<rect width="9.99992" height="13.3333" rx="2.85714" transform="matrix(0 1 1 0 11.6108 13.3335)" fill="#008C82"/>
<g opacity="0.8">
<path opacity="0.8" d="M32.6355 32.0985L41.7825 68.9967C43.0839 74.2471 49.8719 76.0114 51.7423 71.5825L56.9023 59.3581C57.3529 58.2874 58.3055 57.5087 59.4462 57.2785L72.4527 54.6525C77.1633 53.7016 76.7873 46.6988 71.899 44.3775L37.5564 28.0759C34.8761 26.8041 31.9239 29.2174 32.6373 32.097L32.6355 32.0985Z" fill="url(#paint0_linear_3039_5533)"/>
</g>
<defs>
<linearGradient id="paint0_linear_3039_5533" x1="31.3279" y1="30.4888" x2="53.0725" y2="70.7411" gradientUnits="userSpaceOnUse">
<stop stop-color="#F7FF9A"/>
<stop offset="0.421875" stop-color="#9AFFDB"/>
<stop offset="1" stop-color="#19B7AC"/>
</linearGradient>
</defs>
</svg>
`

export const INTEGRATIONS = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M36.5467 13.9239C37.374 13.4463 38.3933 13.4463 39.2206 13.9239L65.4929 29.0921C66.3202 29.5697 66.8298 30.4524 66.8298 31.4077V61.744C66.8298 62.6993 66.3202 63.582 65.4929 64.0596L39.2206 79.2278C38.3933 79.7054 37.374 79.7054 36.5467 79.2278L10.2744 64.0596C9.44712 63.582 8.93746 62.6993 8.93746 61.744V31.4077C8.93746 30.4524 9.44711 29.5697 10.2744 29.0921L36.5467 13.9239Z" fill="#6949B0"/>
<path opacity="0.7" d="M37.9514 38.2588L37.9427 6.096C37.9421 2.76736 41.4999 0.3774 44.0859 1.96931L73.3423 19.979C75.9284 21.5709 75.3959 25.8253 72.4246 27.3224L43.7043 41.8001C40.9047 43.2105 37.9517 41.3926 37.9514 38.2588Z" fill="url(#paint0_linear_3039_5893)"/>
<defs>
<linearGradient id="paint0_linear_3039_5893" x1="31.8675" y1="54.5976" x2="65.5174" y2="0.337093" gradientUnits="userSpaceOnUse">
<stop stop-color="#9D7EF5"/>
<stop offset="1" stop-color="#CFBEFF"/>
</linearGradient>
</defs>
</svg>
`

export const CARD_VAULT = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.9">
<rect width="71.4286" height="52.983" rx="4.28571" transform="matrix(0 1 1 0 3.19189 4.28577)" fill="url(#paint0_linear_3041_6111)"/>
<rect width="11.6077" height="15.4768" rx="2.85714" transform="matrix(1 0 0 -1 12.9028 67.5669)" fill="#A21630"/>
</g>
<g opacity="0.75">
<ellipse cx="55.7281" cy="40.0706" rx="22.0801" ry="22.0801" fill="#CA5D71"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M59.1323 42.3937C61.0867 41.2326 62.3966 39.1002 62.3966 36.662C62.3966 32.9826 59.4139 29.9999 55.7345 29.9999C52.0551 29.9999 49.0724 32.9826 49.0724 36.662C49.0724 39.3999 50.724 41.7521 53.0852 42.7765L49.0723 49.9999H56.2151H63.358L59.1323 42.3937Z" fill="#FFD3DB"/>
</g>
<defs>
<linearGradient id="paint0_linear_3041_6111" x1="35.7143" y1="0" x2="35.7143" y2="52.983" gradientUnits="userSpaceOnUse">
<stop stop-color="#E3456B"/>
<stop offset="1" stop-color="#F895A1"/>
</linearGradient>
</defs>
</svg>
`

export const POS = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34.9092 17.9684V46.4722H63.9362V23.6002C63.9362 20.4947 61.0751 17.9684 57.5581 17.9684H34.9092Z" fill="#FFD494"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.23392 46.6682V23.7962C2.23392 20.6907 5.12074 18.1644 8.66951 18.1644H31.5224V46.6682H2.23392ZM8.66948 78.0484C5.12071 78.0484 2.23389 75.5221 2.23389 72.4166V49.5446H31.5224V78.0484H8.66948ZM34.9219 49.5446V78.0484H57.5707C61.0878 78.0484 63.9489 75.5221 63.9489 72.4166V49.5446H34.9219Z" fill="url(#paint0_linear_3041_6596)"/>
<ellipse opacity="0.8" cx="60.5962" cy="20.1207" rx="18.1695" ry="18.1693" fill="url(#paint1_linear_3041_6596)"/>
<defs>
<linearGradient id="paint0_linear_3041_6596" x1="52.722" y1="26.6666" x2="2.72244" y2="81.111" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFD494"/>
<stop offset="1" stop-color="#FF9365"/>
</linearGradient>
<linearGradient id="paint1_linear_3041_6596" x1="60.5722" y1="2.11154" x2="60.5722" y2="37.9897" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFDB6F"/>
<stop offset="1" stop-color="#F26F87"/>
</linearGradient>
</defs>
</svg>
`

export const CARD_READER = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="36.9332" height="27.3953" rx="2.20322" transform="matrix(4.37114e-08 1 1 -4.37113e-08 26.781 43.0666)" fill="#815AF0"/>
<rect x="17.6245" y="-0.000244141" width="45.7509" height="65.3584" rx="4.88008" fill="url(#paint0_linear_2089_7434)"/>
<rect width="30.0649" height="23.529" rx="3.92151" transform="matrix(-1 0 0 1 55.5325 9.14996)" fill="url(#paint1_linear_2089_7434)" fill-opacity="0.5"/>
<defs>
<linearGradient id="paint0_linear_2089_7434" x1="40.9218" y1="99.9048" x2="25.5955" y2="-3.92554" gradientUnits="userSpaceOnUse">
<stop stop-color="#F3C3FF" stop-opacity="0.51"/>
<stop offset="0.503893" stop-color="#CB82D6"/>
<stop offset="1" stop-color="#815AF0"/>
</linearGradient>
<linearGradient id="paint1_linear_2089_7434" x1="15.686" y1="-1.98205e-07" x2="16.786" y2="22.9114" gradientUnits="userSpaceOnUse">
<stop stop-color="#AF95F8"/>
<stop offset="1" stop-color="#F3C3FF"/>
</linearGradient>
</defs>
</svg>
`

export const REPORTING = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M73.2543 72.5H4.78621C3.20577 72.5 2.11977 70.9108 2.69401 69.4384L12.0568 45.4309C12.4942 44.3093 13.7383 43.7321 14.8771 44.1225L31.4915 49.8173C32.3034 50.0956 33.203 49.8867 33.8092 49.2792L71.6647 11.3434C73.0787 9.92641 75.5 10.9278 75.5 12.9297V70.2543C75.5 71.4946 74.4946 72.5 73.2543 72.5Z" fill="url(#paint0_linear_3041_6958)"/>
<path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M79.8386 21.2925C80.803 22.4281 80.7008 24.1627 79.6101 25.1669L57.7376 45.3057C56.1405 46.7763 53.8971 47.2159 51.8958 46.4504L31.8989 38.8021C31.7253 38.7357 31.531 38.7689 31.3869 38.8894L29.7358 36.7497L31.3869 38.8894L4.78744 61.1401C3.65242 62.0895 1.99308 61.9012 1.0812 60.7194C0.169315 59.5377 0.350197 57.81 1.48521 56.8605L28.0847 34.6099C29.6704 33.2834 31.8076 32.9189 33.7169 33.6491L53.7138 41.2975C53.8958 41.3671 54.0997 41.3271 54.2449 41.1934L76.1174 21.0546C77.208 20.0504 78.8741 20.1569 79.8386 21.2925Z" fill="#A14A5A"/>
<defs>
<linearGradient id="paint0_linear_3041_6958" x1="38.209" y1="30.7452" x2="38.9133" y2="88.67" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF8BA0"/>
<stop offset="1" stop-color="#D5435E"/>
</linearGradient>
</defs>
</svg>
`

export const SUPPORT_TICKETS = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M80.5 32.9352C80.5 17.3188 67.8405 4.6593 52.2241 4.6593H46.8829C34.2165 4.6593 23.9483 14.9275 23.9483 27.594C23.9483 40.2605 34.2165 50.5287 46.883 50.5287H77.3583C79.0934 50.5287 80.5 49.1221 80.5 47.3869V32.9352Z" fill="#125872"/>
<path opacity="0.85" d="M0.5 57.7473C0.5 42.131 13.1595 29.4714 28.7759 29.4714H34.1171C46.7835 29.4714 57.0517 39.7396 57.0517 52.4061C57.0517 65.0726 46.7835 75.3408 34.117 75.3408H3.64175C1.90661 75.3408 0.5 73.9342 0.5 72.1991V57.7473Z" fill="url(#paint0_linear_3037_4680)"/>
<defs>
<linearGradient id="paint0_linear_3037_4680" x1="16.8702" y1="41.6409" x2="21.7188" y2="76.3273" gradientUnits="userSpaceOnUse">
<stop stop-color="#2F9FB8" stop-opacity="0.76"/>
<stop offset="1" stop-color="#8ECBE2" stop-opacity="0.72"/>
</linearGradient>
</defs>
</svg>
`

export const MY_BUSINESS = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="12.7036" y="27.5375" width="55.5932" height="47.782" rx="4.28571" fill="#815AF0"/>
<path opacity="0.85" d="M12.1186 7.61693C12.7001 5.86379 14.3394 4.68042 16.1864 4.68042H65.4963C67.3713 4.68042 69.0286 5.89924 69.5873 7.68904L78.7635 37.0837C79.6249 39.8432 77.5632 42.6465 74.6725 42.6465H6.43679C3.51423 42.6465 1.44892 39.7856 2.36899 37.0116L12.1186 7.61693Z" fill="url(#paint0_linear_3042_7162)"/>
<defs>
<linearGradient id="paint0_linear_3042_7162" x1="17.5213" y1="20.3621" x2="20.1587" y2="44.8384" gradientUnits="userSpaceOnUse">
<stop stop-color="#C7BCFD"/>
<stop offset="1" stop-color="#AF95F8"/>
</linearGradient>
</defs>
</svg>
`

export const EMPLOYEES = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="14.8716" y="11.4" width="51.2571" height="67.6" rx="2.925" fill="url(#paint0_linear_2903_9444)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M46.2752 42.913C48.0544 41.2715 49.1687 38.9203 49.1687 36.3087C49.1687 31.3472 45.1465 27.325 40.1849 27.325C35.2233 27.325 31.2012 31.3472 31.2012 36.3087C31.2012 38.9203 32.3155 41.2715 34.0946 42.913C29.5153 45.1645 26.3638 49.8759 26.3638 55.3234V60.0398C26.3638 60.87 27.0367 61.5429 27.8668 61.5429H52.503C53.3331 61.5429 54.006 60.87 54.006 60.0398V55.3234C54.006 49.8759 50.8545 45.1645 46.2752 42.913Z" fill="url(#paint1_linear_2903_9444)"/>
<rect opacity="0.8" x="34.9287" y="1" width="10.4" height="16.3429" rx="1.60102" fill="#9BD5B0"/>
<defs>
<linearGradient id="paint0_linear_2903_9444" x1="40.5002" y1="11.4" x2="40.5002" y2="79" gradientUnits="userSpaceOnUse">
<stop stop-color="#108F80"/>
<stop offset="1" stop-color="#12B9A5"/>
</linearGradient>
<linearGradient id="paint1_linear_2903_9444" x1="40.1849" y1="27.325" x2="39.9808" y2="139.84" gradientUnits="userSpaceOnUse">
<stop stop-color="#D4EDDD"/>
<stop offset="1" stop-color="#D4EDDD" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
`

export const BANKING = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="44.25" y="77.5" width="75" height="27.5" rx="2.74509" transform="rotate(-90 44.25 77.5)" fill="url(#paint0_linear_3042_7368)"/>
<rect x="54.2502" y="72.5" width="65" height="7.5" rx="2.74509" transform="rotate(-90 54.2502 72.5)" fill="#AA6243"/>
<path d="M61.75 62.9129C56.174 68.0867 48.7064 71.25 40.4999 71.25C23.2411 71.25 9.25 57.2589 9.25 40C9.25 22.7411 23.2411 8.75 40.4999 8.75C48.7064 8.75 56.174 11.9133 61.75 17.0871C61.75 17.0871 61.75 56.8755 61.75 62.9129Z" fill="url(#paint1_linear_3042_7368)"/>
<defs>
<linearGradient id="paint0_linear_3042_7368" x1="118" y1="82.5" x2="19.875" y2="93.75" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFA47D"/>
<stop offset="1" stop-color="#A36247"/>
</linearGradient>
<linearGradient id="paint1_linear_3042_7368" x1="40.4999" y1="8.75" x2="40.4999" y2="71.25" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFEACA"/>
<stop offset="1" stop-color="#FFB445" stop-opacity="0.7"/>
</linearGradient>
</defs>
</svg>
`

export const ACCOUNTING_CENTER = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50.2019 27.4794L11.812 50.0127C9.93086 51.1168 9.93086 53.8366 11.812 54.9408L50.2019 77.4741C52.1066 78.592 54.5054 77.2186 54.5054 75.01L54.5054 29.9434C54.5054 27.7349 52.1066 26.3614 50.2019 27.4794Z" fill="url(#paint0_linear_3042_7611)"/>
<path opacity="0.5" d="M30.6769 49.5629L68.2836 28.086C70.2508 26.9625 70.1906 24.106 68.1778 23.0664L29.6997 3.19278C27.7745 2.19843 25.4864 3.62518 25.5321 5.79152L26.4035 47.1421C26.4491 49.3084 28.7953 50.6375 30.6769 49.5629Z" fill="url(#paint1_linear_3042_7611)"/>
<defs>
<linearGradient id="paint0_linear_3042_7611" x1="7.61401" y1="52.4767" x2="54.5054" y2="52.4767" gradientUnits="userSpaceOnUse">
<stop stop-color="#E3456B"/>
<stop offset="1" stop-color="#F895A1"/>
</linearGradient>
<linearGradient id="paint1_linear_3042_7611" x1="73.16" y1="17.2538" x2="11.2431" y2="23.3125" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFC0F1"/>
<stop offset="0.338542" stop-color="#F26F87"/>
<stop offset="1" stop-color="#CF415B"/>
</linearGradient>
</defs>
</svg>
`

export const INVENTORY_MANAGEMENT = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="14.4" width="56" height="62.4" rx="4" fill="#FFB47D"/>
<rect opacity="0.8" x="24.5" y="34.5995" width="56" height="41.9997" rx="4" fill="url(#paint0_linear_3042_7817)"/>
<rect x="34.1001" y="3.20001" width="33.6" height="32" rx="4" fill="url(#paint1_linear_3042_7817)" fill-opacity="0.9"/>
<defs>
<linearGradient id="paint0_linear_3042_7817" x1="52.5" y1="34.5995" x2="52.5" y2="76.5992" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFD494"/>
<stop offset="1" stop-color="#FFE889"/>
</linearGradient>
<linearGradient id="paint1_linear_3042_7817" x1="44.1801" y1="14.0108" x2="49.3374" y2="31.6251" gradientUnits="userSpaceOnUse">
<stop stop-color="#E79458"/>
<stop offset="1" stop-color="#BD6B49"/>
</linearGradient>
</defs>
</svg>
`

export const PAYMENT_PAGES = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="39.0791" height="50.3914" rx="4.15" transform="matrix(0.866046 -0.499965 0.866046 0.499965 1.60547 54.8058)" fill="url(#paint0_linear_3037_6809)"/>
<g opacity="0.85">
<rect width="39.0791" height="50.3914" rx="4.15" transform="matrix(0.866046 -0.499965 0.866046 0.499965 1.90918 38.4258)" fill="url(#paint1_linear_3037_6809)"/>
</g>
<rect width="39.0791" height="50.3914" rx="4.15" transform="matrix(0.866046 -0.499965 0.866046 0.499965 1.60547 19.5388)" fill="url(#paint2_linear_3037_6809)"/>
<defs>
<linearGradient id="paint0_linear_3037_6809" x1="11.3124" y1="13.3691" x2="19.5395" y2="50.3914" gradientUnits="userSpaceOnUse">
<stop stop-color="#2F9FB8"/>
<stop offset="1" stop-color="#1A7DA3"/>
</linearGradient>
<linearGradient id="paint1_linear_3037_6809" x1="11.3124" y1="13.3691" x2="19.5395" y2="50.3914" gradientUnits="userSpaceOnUse">
<stop stop-color="#2F9FB8" stop-opacity="0.76"/>
<stop offset="1" stop-color="#8ECBE2" stop-opacity="0.72"/>
</linearGradient>
<linearGradient id="paint2_linear_3037_6809" x1="11.3124" y1="13.3691" x2="19.5395" y2="50.3914" gradientUnits="userSpaceOnUse">
<stop stop-color="#2F9FB8"/>
<stop offset="1" stop-color="#1A7DA3"/>
</linearGradient>
</defs>
</svg>
`

export const ONLINE_CHECKOUT = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M73.0775 32.3251C76.5856 32.3251 79.0569 35.77 77.9327 39.0931L66.2281 73.6899C65.5238 75.7717 63.5706 77.1728 61.3729 77.1728H19.6268C17.4291 77.1728 15.476 75.7717 14.7717 73.6899L3.06707 39.0931C1.94283 35.77 4.41413 32.3251 7.92221 32.3251L73.0775 32.3251Z" fill="url(#paint0_linear_3042_8062)"/>
<rect x="0.777344" y="32.1862" width="79.4451" height="11.5323" rx="3.20342" fill="#CA5D71"/>
<rect opacity="0.8" width="16.1238" height="45.2874" rx="5.12547" transform="matrix(0.807101 -0.590414 0.590419 0.807097 13.8335 12.3469)" fill="url(#paint1_linear_3042_8062)"/>
<defs>
<linearGradient id="paint0_linear_3042_8062" x1="40.1875" y1="48.3634" x2="40.4998" y2="88.333" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF8BA0"/>
<stop offset="1" stop-color="#D5435E"/>
</linearGradient>
<linearGradient id="paint1_linear_3042_8062" x1="5.46259" y1="-0.467956" x2="-5.56798" y2="50.3993" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFC0F1"/>
<stop offset="0.338542" stop-color="#F26F87"/>
<stop offset="1" stop-color="#793844"/>
</linearGradient>
</defs>
</svg>
`

export const SMART_TERMINAL = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="12.6028" y="1" width="42.1967" height="78" rx="4.77376" fill="url(#paint0_linear_2107_4451)"/>
<rect width="48.5902" height="29.4099" rx="3.83607" transform="matrix(7.16152e-08 -1 -1 -1.04448e-07 48.4062 72.6065)" fill="url(#paint1_linear_2107_4451)" fill-opacity="0.5"/>
<rect width="36.1286" height="26.7984" rx="2.15522" transform="matrix(-1 0 0 1 68.3972 13.2712)" fill="url(#paint2_linear_2107_4451)"/>
<defs>
<linearGradient id="paint0_linear_2107_4451" x1="34.0902" y1="120.229" x2="10.7586" y2="-1.92811" gradientUnits="userSpaceOnUse">
<stop stop-color="#815AF0"/>
<stop offset="0.463542" stop-color="#CB82D6"/>
<stop offset="1" stop-color="#F3C3FF"/>
</linearGradient>
<linearGradient id="paint1_linear_2107_4451" x1="48.2066" y1="23.5062" x2="8.14336" y2="31.4392" gradientUnits="userSpaceOnUse">
<stop stop-color="#FAE8FF"/>
<stop offset="1" stop-color="#F3C3FF"/>
</linearGradient>
<linearGradient id="paint2_linear_2107_4451" x1="38.0678" y1="14.9285" x2="-1.49285" y2="14.9285" gradientUnits="userSpaceOnUse">
<stop stop-color="#815AF0" stop-opacity="0.42"/>
<stop offset="1" stop-color="#815AF0"/>
</linearGradient>
</defs>
</svg>
`

export const EQUIPMENT = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="30.4414" y="11.9661" width="41.7591" height="60.849" rx="4.45429" fill="url(#paint0_linear_2089_7871)"/>
<rect width="27.4417" height="21.4761" rx="3.57935" transform="matrix(-1 0 0 1 65.0417 20.3179)" fill="url(#paint1_linear_2089_7871)" fill-opacity="0.5"/>
<rect x="8.79956" y="0.0350952" width="39.3729" height="72.7802" rx="4.45429" fill="url(#paint2_linear_2089_7871)"/>
<rect width="45.3385" height="27.4417" rx="3.57935" transform="matrix(7.16151e-08 -1 -1 -1.04448e-07 42.2065 66.8497)" fill="url(#paint3_linear_2089_7871)" fill-opacity="0.5"/>
<rect x="26.5" y="49.035" width="30.9298" height="30.9298" rx="15.4649" fill="url(#paint4_linear_2089_7871)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M43.4648 55.7499C43.4648 55.0596 42.9052 54.4999 42.2148 54.4999C41.5245 54.4999 40.9648 55.0596 40.9648 55.7499V63.4999L33.2148 63.4999C32.5245 63.4999 31.9648 64.0596 31.9648 64.7499C31.9648 65.4403 32.5245 65.9999 33.2148 65.9999L40.9648 65.9999V73.2499C40.9648 73.9403 41.5245 74.4999 42.2148 74.4999C42.9052 74.4999 43.4648 73.9403 43.4648 73.2499V65.9999L50.7148 65.9999C51.4052 65.9999 51.9648 65.4403 51.9648 64.7499C51.9648 64.0596 51.4052 63.4999 50.7148 63.4999L43.4648 63.4999V55.7499Z" fill="white"/>
<defs>
<linearGradient id="paint0_linear_2089_7871" x1="51.706" y1="104.978" x2="37.1642" y2="8.39487" gradientUnits="userSpaceOnUse">
<stop stop-color="#F3C3FF" stop-opacity="0.51"/>
<stop offset="0.503893" stop-color="#CB82D6"/>
<stop offset="1" stop-color="#815AF0"/>
</linearGradient>
<linearGradient id="paint1_linear_2089_7871" x1="14.3174" y1="-1.80912e-07" x2="15.3214" y2="20.9124" gradientUnits="userSpaceOnUse">
<stop stop-color="#AF95F8"/>
<stop offset="1" stop-color="#F3C3FF"/>
</linearGradient>
<linearGradient id="paint2_linear_2089_7871" x1="48.1724" y1="51.3391" x2="12.316" y2="-1.49068" gradientUnits="userSpaceOnUse">
<stop stop-color="#CB82D6"/>
<stop offset="1" stop-color="#F3C3FF"/>
</linearGradient>
<linearGradient id="paint3_linear_2089_7871" x1="45.2788" y1="27.9785" x2="4.77608" y2="31.7841" gradientUnits="userSpaceOnUse">
<stop stop-color="#FAE8FF"/>
<stop offset="1" stop-color="#F3C3FF"/>
</linearGradient>
<linearGradient id="paint4_linear_2089_7871" x1="49.1819" y1="79.9649" x2="40.7505" y2="45.1596" gradientUnits="userSpaceOnUse">
<stop stop-color="#815AF0" stop-opacity="0.75"/>
<stop offset="1" stop-color="#6949B0"/>
</linearGradient>
</defs>
</svg>
`

export const APP_DEVICES = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="5.134" width="70.382" height="53.9254" rx="3.73238" fill="#6949B0"/>
<rect x="5.48633" y="9.03751" width="60.824" height="46.8532" rx="2.14286" fill="url(#paint0_linear_2271_4177)"/>
<g opacity="0.8">
<rect x="50.6206" y="24.7455" width="29.8795" height="50.1204" rx="3.19918" fill="#7552D0"/>
<rect width="42.0365" height="23.5891" rx="2.14286" transform="matrix(6.96581e-08 -1 -1 -1.07382e-07 77.355 70.824)" fill="url(#paint1_linear_2271_4177)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2271_4177" x1="48.813" y1="48.6498" x2="10.7451" y2="3.04918" gradientUnits="userSpaceOnUse">
<stop stop-color="#7145D2"/>
<stop offset="1" stop-color="#F3C3FF" stop-opacity="0.51"/>
</linearGradient>
<linearGradient id="paint1_linear_2271_4177" x1="41.7046" y1="18.8539" x2="7.25735" y2="26.211" gradientUnits="userSpaceOnUse">
<stop stop-color="#CAB7FF"/>
<stop offset="1" stop-color="#9E7BFF"/>
</linearGradient>
</defs>
</svg>
`

export const SETTINGS = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.75" d="M77.9215 26.0938C78.5465 27.5 78.0778 28.9062 76.984 30L70.2653 36.0938C70.4215 37.3438 70.4215 38.75 70.4215 40C70.4215 41.4062 70.4215 42.8125 70.2653 44.0625L76.984 50.1562C78.0778 51.0938 78.5465 52.6562 77.9215 54.0625C77.2965 55.9375 76.5153 57.6562 75.5778 59.375L74.7965 60.625C73.7028 62.3438 72.609 64.0625 71.359 65.4688C70.4215 66.7188 68.859 67.0312 67.4528 66.5625L58.859 63.9062C56.6715 65.4688 54.3278 66.7188 51.984 67.8125L49.9528 76.7188C49.6403 78.125 48.5465 79.2188 47.1403 79.5312C44.9528 79.8438 42.7653 80 40.4215 80C38.234 80 36.0465 79.8438 33.859 79.5312C32.4528 79.2188 31.359 78.125 31.0465 76.7188L29.0153 67.8125C26.5153 66.7188 24.3278 65.4688 22.1403 63.9062L13.5465 66.5625C12.1403 67.0312 10.5778 66.7188 9.64029 65.625C8.39029 64.0625 7.29654 62.3438 6.20279 60.625L5.42154 59.375C4.48404 57.6562 3.70279 55.9375 3.07779 54.0625C2.45279 52.6562 2.92154 51.25 4.01529 50.1562L10.734 44.0625C10.5778 42.8125 10.5778 41.4062 10.5778 40C10.5778 38.75 10.5778 37.3438 10.734 36.0938L4.01529 30C2.92154 28.9062 2.45279 27.5 3.07779 26.0938C3.70279 24.2188 4.48404 22.5 5.42154 20.7812L6.20279 19.5312C7.29654 17.8125 8.39029 16.0938 9.64029 14.5312C10.5778 13.4375 12.1403 13.125 13.5465 13.5938L22.1403 16.25C24.3278 14.6875 26.6715 13.2812 29.0153 12.3438L31.0465 3.4375C31.359 2.03125 32.4528 0.9375 33.859 0.625C36.0465 0.3125 38.234 0 40.5778 0C42.7653 0 44.9528 0.3125 47.1403 0.625C48.5465 0.78125 49.6403 2.03125 49.9528 3.4375L51.984 12.3438C54.484 13.2812 56.6715 14.6875 58.859 16.25L67.4528 13.5938C68.859 13.125 70.4215 13.4375 71.359 14.5312C72.609 16.0938 73.7028 17.8125 74.7965 19.5312L75.5778 20.7812C76.5153 22.5 77.2965 24.2188 78.0778 26.0938H77.9215ZM40.5778 52.5C47.4528 52.5 53.0778 47.0312 53.0778 40C53.0778 33.125 47.4528 27.5 40.5778 27.5C33.5465 27.5 28.0778 33.125 28.0778 40C28.0778 47.0312 33.5465 52.5 40.5778 52.5Z" fill="url(#paint0_linear_3042_8319)"/>
<defs>
<linearGradient id="paint0_linear_3042_8319" x1="40.5776" y1="14.2857" x2="40.4022" y2="72.8566" gradientUnits="userSpaceOnUse">
<stop stop-color="#CEC9F1"/>
<stop offset="1" stop-color="#A29DC4"/>
</linearGradient>
</defs>
</svg>
`

export const HOME = `<svg viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50.0728 79.2737C42.333 76.6611 41.3409 68.5203 42.924 61.6683C43.304 59.3585 44.0217 56.5134 44.7886 52.9923C45.5978 49.3304 46.2662 46.4854 46.6532 44.4642C47.0246 42.6355 47.2481 40.7797 47.3217 38.915C47.3217 35.1122 45.9848 33.0841 43.304 33.0841C41.4394 33.0841 36.6126 34.5911 34.551 43.5488C34.551 43.5488 33.4744 49.7529 30.0267 63.9218C25.4461 86.7455 14.9552 79.1259 5.92773 75.633C8.56631 75.471 11.7607 71.9006 13.4565 65.8936C19.2613 45.3656 27.367 2.81678 27.367 2.81678L44.3876 -9.15527e-05L37.7102 28.9644C39.6039 26.7254 41.9941 24.9602 44.6901 23.8095C46.6345 23.0893 48.6892 22.7129 50.7623 22.6969C54.5408 22.6969 57.5101 23.6616 59.8039 25.6898C62.1047 27.8588 63.322 31.1334 63.322 35.4714C63.1856 38.9061 62.688 42.317 61.8373 45.6473C61.5488 46.8515 61.1689 48.6332 60.6412 51.0909C59.5365 55.1402 56.9401 64.8302 60.5356 68.9218C65.1373 74.1541 72.3283 65.4007 75.0724 60.288C71.3925 79.9568 56.2928 81.3864 50.0728 79.2737Z" fill="#815AF0"/>
</svg>
`

export const CHARGEBACKS = `<svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="none">
<ellipse cx="35.9115" cy="44.2857" rx="35.7143" ry="35.7143" fill="url(#paint0_linear_3840_5829)"/>
<ellipse cx="35.9114" cy="44.2857" rx="27.1429" ry="27.1429" fill="#FFB342"/>
<path opacity="0.67" fill-rule="evenodd" clip-rule="evenodd" d="M27.0245 21.2183C25.5407 22.362 25.5407 24.6003 27.0245 25.744L53.7731 46.3628C55.6516 47.8108 58.3745 46.4717 58.3745 44.0999V33.3919L75.2016 46.3628C77.0801 47.8108 79.8031 46.4717 79.8031 44.0999V2.8624C79.8031 0.49058 77.0801 -0.848495 75.2016 0.599523L58.3745 13.5704V2.8624C58.3745 0.49058 55.6516 -0.848495 53.7731 0.599523L27.0245 21.2183Z" fill="url(#paint1_linear_3840_5829)"/>
<defs>
<linearGradient id="paint0_linear_3840_5829" x1="42.7141" y1="8.57144" x2="40.1973" y2="122.143" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFD89D"/>
<stop offset="1" stop-color="#FFB445"/>
</linearGradient>
<linearGradient id="paint1_linear_3840_5829" x1="31.5" y1="53" x2="116.465" y2="-43.5069" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF6F42"/>
<stop offset="1" stop-color="#FFEACA"/>
</linearGradient>
</defs>
</svg>
`